import * as React from "react"

import { cn } from "@/lib/utils"

interface ToggleProps extends React.ComponentProps<"input"> {
  title?: string;
}

const Toggle = React.forwardRef<HTMLInputElement, ToggleProps>(


  ({ className, title, ...props }, ref) => {
    React.useEffect(() => {
      console.log("Toggle received checked:", props.checked);
    }, [props.checked]);
    
    return (
      <div className="flex items-center gap-[5px] whitespace-nowrap">

      <label className="relative inline-block w-8 h-3 peer">
  <input
    type="checkbox"
    className="sr-only peer"
    ref={ref}
    {...props}
  />
  <div
    className="absolute inset-0 bg-gray-300 dark:bg-gray-500 rounded-full transition peer-checked:bg-sky-300 dark:peer-checked:bg-orange-800 peer-focus:ring-1 peer-focus:ring-[#7dd3fc] dark:peer-focus:ring-[#991b1b]"
  ></div>
  <div
    className="absolute w-4 h-4 bg-sky-600 dark:bg-orange-400 rounded-full bottom-[-2px] left-0 transition-transform duration-300 peer-checked:translate-x-5"
  ></div>
</label>
{title && <span className="pl-2 text-sm">{title}</span>}

</div>

      
    )
  }
)

Toggle.displayName = "Toggle"

export { Toggle }
